//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MdmSkipTo from '~/components/atoms/Global/MdmSkipTo.vue';
export default {
  components: {
    MdmSkipTo
  },

  data() {
    return {
      hideNavigation: true,
      keyboardNavigationEnabled: true,
      skipLinks: [{
        text: this.$t('content'),
        to: '#main-content'
      }, {
        text: this.$t('navigation'),
        to: '#main-navigation'
      }]
    };
  },

  mounted() {
    window.addEventListener('keyup', this.handleNavigation);
    document.addEventListener('keydown', this.handleKeyboardInput, true);
    document.addEventListener('click', this.handleMouseInput, true);
  },

  destroyed() {
    document.removeEventListener('keydown', this.handleKeyboardInput, true);
    document.removeEventListener('click', this.handleMouseInput, true);
  },

  methods: {
    handleNavigation(e) {
      if (e.keyCode !== 9) return;
      this.hideNavigation = !this.$el.contains(document.activeElement);
    },

    handleKeyboardInput(e) {
      const isKeyboardKey = e.key === 'Tab' || e.code === 'Tab' || e.keyCode === 9 || e.keyCode === 38 || e.keyCode === 40;

      if (isKeyboardKey) {
        this.keyboardNavigationEnabled = true;
      }
    },

    handleMouseInput() {
      if (this.keyboardNavigationEnabled) {
        this.keyboardNavigationEnabled = false;
      }
    }

  },

  head() {
    return {
      bodyAttrs: {
        class: this.keyboardNavigationEnabled ? 'is-using-keyboard' : ''
      }
    };
  }

};